import { PVHoverNavy } from '@pv/common/colors';

export const reportSx = {
  '& .MuiDataGrid-columnHeaderTitle': {
    color: 'rgba(38, 50, 56, 0.54)',
    fontWeight: 'regular',
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    padding: '8px 16px',
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    borderBottom: '1px solid rgb(224, 224, 224)',
    borderTop: '1px solid rgb(224, 224, 224)',
    padding: '0 16px',
  },
  '& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-hovered': {
    bgcolor: PVHoverNavy,
    cursor: 'pointer',
  },
};
